// lib
import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import useNonInitialEffect from '@aytm/app/stats/page/components/hooks/useNonInitialEffect'

// components
import { RadioButton } from 'primereact/radiobutton'

// styles
import style from '@aytm/app/stats/page/sidebar/completes/styles/CompletesPanel.module.scss'

const CompletesPanel = ({ model, onParamsChange }) => {
  const { loadUnfinishedCS } = model

  const [unfinished, setUnfinished] = useState(loadUnfinishedCS)

  useEffect(() => setUnfinished(loadUnfinishedCS), [loadUnfinishedCS])

  // Emit only when the toggle differs from the model, so a model-originated sync doesn't echo back a params change.
  useNonInitialEffect(() => {
    if (!unfinished !== !loadUnfinishedCS) onParamsChange({ filters_unfinished: unfinished ? true : null })
  }, [unfinished, onParamsChange])

  return (
    <div className={style.component}>
      <div className={style['component-title']}>Filter By Completes</div>

      <div className={`${style.row} ${style['row-indent']}`}>
        <div className={`${style.param} p-col-12`}>
          <RadioButton
            aria-labelledby="stat-completes-option-0-label"
            value="0"
            checked={!unfinished}
            onChange={() => setUnfinished(false)}
          />
          <span id="stat-completes-option-0-label" className={style['row-label']} onClick={() => setUnfinished(false)}>
            Show only full completes
          </span>
        </div>
      </div>
      <div className={`${style.row} ${style['row-indent']}`}>
        <div className={`${style.param} p-col-12`}>
          <RadioButton
            aria-labelledby="stat-completes-option-1-label"
            value="1"
            checked={unfinished}
            onChange={() => setUnfinished(true)}
          />
          <span id="stat-completes-option-1-label" className={style['row-label']} onClick={() => setUnfinished(true)}>
            Show all - partial and full completes
          </span>
        </div>
      </div>
    </div>
  )
}

CompletesPanel.propTypes = {
  model: PropTypes.object,
  onParamsChange: PropTypes.func
}

CompletesPanel.displayName = 'CompletesPanel'

export default CompletesPanel
